import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    fi: {
      translation: require('../localization/fi.json'),
    },
    sv: {
      translation: require('../localization/sv.json'),
    },
    en: {
      translation: require('../localization/en.json'),
    },
  },
  debug: process.env.NODE_ENV === 'development',
  //fallbackLng: process.env.GATSBY_SITE_DOMAIN === 'com' ? 'en' : 'fi',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
